import { render, staticRenderFns } from "./settingsList.vue?vue&type=template&id=28ccbd7c"
import script from "./settingsList.vue?vue&type=script&lang=js"
export * from "./settingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports